import { useState, useEffect } from 'react';

export function BagDetail({ bagId }: { bagId: number }) {
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    fetch(`/api/warehouse/bags/${bagId}`, { credentials: 'include' })
      .then((r) => r.json())
      .then(setData)
      .catch(() => setData({ items: [] }));
  }, [bagId]);
  if (!data) return <div className="p-3 text-sm">Cargando...</div>;
  const courier = data.bag?.courier ?? null;
  return (
    <div className="border-t border-gray-200 p-3">
      {/* 2026-09-10 — correo de la bolsa (depósito con dos correos) */}
      {data.bag && (
        <div className="mb-2 text-xs text-gray-600">
          Correo:{' '}
          {courier ? (
            <span className="rounded px-2 py-0.5 font-semibold text-white" style={{ backgroundColor: courier.color }}>
              {courier.name}
            </span>
          ) : (
            <span className="italic">sin correo todavía (lo fija el primer paquete)</span>
          )}
        </div>
      )}
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-gray-500">
            <th>ML Order</th>
            <th>Tracking</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {(data.items ?? []).map((i: any) => (
            <tr key={i.id} className="border-t border-gray-100">
              <td>{i.ml_order_id ?? '—'}</td>
              <td className="font-mono">{i.amazon_tracking ?? '—'}</td>
              <td>{i.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
